<template>
    <div class="page page--environment environment">
        <div class="cta">
            <div class="cta__content">
            </div>
        </div>
        <div class="page__content">
            <div class="page__content__block">
                <div>
                    <h1>{{$t('environment.title')}}</h1>
                </div>
                <div v-html="$t('environment.text')"></div>
            </div>
        </div>
        <GmapMap class="environment__map" :options="mapOptions" :center="mapCenter" :zoom="mapZoom">
            <GmapInfoWindow :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
            </GmapInfoWindow>
            <GmapMarker
                    v-for="(item,index) in markers"
                    :key="'marker--'+index"
                    :position="item.position"
                    :clickable="true"
                    :draggable="false"
                    @click="toggleInfoWindow(item,index)"
            />
        </GmapMap>
    </div>
</template>

<script>
    export default {
        name: "Environment",
        data() {
            return {
                infoOptions: {
                    content: '',
                    pixelOffset: {
                        width: 0,
                        height: -35
                    }
                },
                infoWindowPos: null,
                infoWinOpen: false,
                currentMidx: null,
                mapCenter: {lat: 66.19, lng: 28.4},
                markers: [
                    {label: 'Iivaara Wilderness Lodge', position: {lat: 65.823378, lng: 29.5496654}},
                    {label: 'Kuusamo Airport', position: {lat: 65.9874597, lng: 29.2394613}},
                    {label: 'Iivaara natuurpark', position: {lat: 65.801022, lng: 29.6838422}},
                    {label: 'Ruka', position: {lat: 66.1551676, lng: 29.1160846}},
                    {label: 'Kuusamo', position: {lat: 65.965817, lng: 29.181741}},
                    {label: 'Rovaniemi, dorp van Santa Claus', position: {lat:66.504429,lng:25.729494}}
                ],
                mapZoom: 8,
                mapOptions: {
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    disableDefaultUi: false,
                    styles: [
                        {
                            "featureType": "poi",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#C5E3BF"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "lightness": 100
                                },
                                {
                                    "visibility": "simplified"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#D1D1B8"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#93D1EA"
                                }
                            ]
                        }
                    ]
                }
            }
        },
        methods:{
            toggleInfoWindow(marker, id) {
                this.infoWindowPos = marker.position;
                this.infoOptions.content = marker.label;

                if (this.currentMidx === id) {
                    this.infoWinOpen = !this.infoWinOpen;
                }
                else {
                    this.infoWinOpen = true;
                    this.currentMidx = id;
                }
            }
        }
    }
</script>